document.addEventListener('DOMContentLoaded', () => {
  /** Set zero/single/multiple class on an input and resize to fit */
  function updateSuffixClass(input) {
    const val = Number(input.value) || 0;
    input.classList.remove('zero', 'single', 'multiple');
    input.classList.add(val === 0 ? 'zero' : val === 1 ? 'single' : 'multiple');
    input.style.width = input.value.length + 1 + 'ch';
  }

  document.querySelectorAll('.custom-product .quantity__input').forEach((input) => {
    input.addEventListener('change', () => updateSuffixClass(input));
    input.addEventListener('input', () => updateSuffixClass(input));
  });
});
